import { GetShippingProfiles, GetOwnedProducts } from "../queries";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { useState } from "react";
import { filterProducts, formatVariants } from "./helper";
import useInputState from "../../../../hooks/useInputState";
import { createShippingProfile } from "../mutation";
import useTutorialsState from "../../../../hooks/useTutorialsState";
import useTagAccount from "../../../../hooks/useTagAccount";

export const useShippingProfile = () => {
  const { data, loading } = useQuery(GetShippingProfiles);
  const account = data && data.accounts && data.accounts[0];
  const shippingProfiles =
    account &&
    account.shippingProfiles.map(({ products, ...profile }) => {
      return { productCount: products.length, ...profile };
    });

  return {
    loading,
    shippingProfiles
  };
};

export const useCreateShippingProfile = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productIds, setProductIds] = useState([]);
  const [searchText, setSearchText] = useInputState("");
  const [profileName, setProfileName] = useInputState("");
  const [isSaving, setIsSaving] = useState(false);
  const { getHasCompletedTutorial, completeTutorial } = useTutorialsState();
  const { tagAccount } = useTagAccount();

  const [saveShippingProfile] = useMutation(createShippingProfile, {
    variables: {
      shippingProfile: {
        name: profileName,
        productIds
      }
    },
    refetchQueries: [
      {
        query: GetOwnedProducts
      },
      {
        query: GetShippingProfiles
      }
    ]
  });

  const onCloseDialog = () => {
    setSearchText("");
    setProductIds([]);
    setProfileName("");
    setIsModalOpen(false);
    setIsSaving(false);
  };
  const onCreateShippingProfile = async () => {
    setIsSaving(true);
    try {
      await saveShippingProfile();

      const hasShippingProfile = getHasCompletedTutorial(
        "Add Shipping Profile"
      );

      if (!hasShippingProfile) {
        await completeTutorial({
          variables: {
            name: "Add Shipping Profile",
            version: 1
          }
        });

        await tagAccount("Shipping Info Provided");
      }
    } catch (e) {
      setIsSaving(false);
    }
    onCloseDialog();
  };
  return {
    isModalOpen,
    setIsModalOpen,
    onCloseDialog,
    productIds,
    setProductIds,
    searchText,
    setSearchText,
    profileName,
    setProfileName,
    onCreateShippingProfile,
    isSubmitDisabled: !profileName || !productIds.length,
    isSaving
  };
};

export function useProductsList(searchText, isModalOpen, shippingProfileId) {
  const { data, loading } = useQuery(GetOwnedProducts, {
    variables: {
      name: { contains: searchText }
    },
    skip: !isModalOpen
  });

  const productList =
    (data &&
      data.stores &&
      filterProducts(data.stores.ownedProducts, shippingProfileId).map(
        (product) => {
          return {
            value: product.id,
            text: product.name,
            imageUrl: product.images[0].url,
            ...(product.variants.length && {
              children: formatVariants(product.variants, shippingProfileId)
            })
          };
        }
      )) ||
    [];

  return {
    loading,
    productList
  };
}
